import React, { useEffect, useMemo } from 'react';
import { ICertificateDTO } from '../../../dtos/ICertificatesProps';
import api from '../../../services/api';
import {
  ActionButtonsDownload,
  CertificateCard,
  CertificateDate,
  CertificatesSection,
  CertificateTitle,
  Container,
  NoCertificatesMessage,
  Title,
} from './styles';
import CertificatesIcon from '../../../assets/svg/SVGComponents/CertificatesIcon';
import { useAuth } from '../../../hooks/auth';

// import { Container } from './styles';

const ProfileCertificates: React.FC = () => {
  const { user } = useAuth();
  const [certificateData, setCertificateData] = React.useState<
    ICertificateDTO[] | null
  >(null);
  useEffect(() => {
    const fetchCertificates = async (): Promise<void> => {
      try {
        const response = await api.get('/certificates/list');
        const { data } = response;

        if (Array.isArray(data)) {
          setCertificateData(data);
        } else if (data?.certificates && Array.isArray(data.certificates)) {
          setCertificateData(data.certificates);
        } else if (data?.data && Array.isArray(data.data)) {
          setCertificateData(data.data);
        } else {
          setCertificateData([]);
        }
      } catch {
        setCertificateData([]);
      }
    };
    fetchCertificates();
  }, []);

  /**
   * Extrai o nome/título do certificado a partir de certificate_data.
   * certificate_data pode ser JSON (com campo name/title/event) ou texto puro.
   */
  const getCertificateName = (certData: string): string => {
    if (!certData) return 'Certificado';
    try {
      const parsed = JSON.parse(certData);
      return (
        parsed.name ||
        parsed.title ||
        parsed.event ||
        parsed.event_name ||
        parsed.course_name ||
        'Certificado'
      );
    } catch {
      // Se não é JSON, usar o texto diretamente
      return certData || 'Certificado';
    }
  };

  return (
    <Container className="profile-certificates-container">
      <Title>
        <CertificatesIcon
          width="1.7rem"
          stroke="#323232"
          strokeWidth={1.5}
          fill="none"
        />
        <h1>Certificados</h1>
      </Title>
      <CertificatesSection>
        {certificateData && certificateData.length > 0 ? (
          certificateData.map(certificate => (
            <CertificateCard key={certificate.id}>
              <CertificateTitle>
                {getCertificateName(certificate.certificate_data)}
              </CertificateTitle>
              <span>{user.name}</span>
              <CertificateDate>
                Emitido em:{' '}
                {new Date(certificate.created_at).toLocaleDateString()}
              </CertificateDate>
              <ActionButtonsDownload>
                <button type="button">Compartilhar</button>
                <button type="button">Baixar Certificado</button>
              </ActionButtonsDownload>
            </CertificateCard>
          ))
        ) : (
          <NoCertificatesMessage>
            Você ainda não possui certificados.
          </NoCertificatesMessage>
        )}
      </CertificatesSection>
    </Container>
  );
};

export default ProfileCertificates;
